import {
  isMindmapNode,
  getConnectedChildren,
  toggleMindmapCollapse,
  CaptureUpdateAction,
} from "@excalidraw/element";

import { getSelectedElements } from "../scene";

import { register } from "./register";

export const actionToggleMindMapCollapse = register({
  name: "toggleMindMapCollapse",
  label: "labels.toggleMindMapCollapse",
  viewMode: false,
  trackEvent: {
    category: "element",
  },
  predicate: (elements, appState, _, app) => {
    if (!appState.mindMapModeEnabled) {
      return false;
    }
    const selected = getSelectedElements(
      app.scene.getNonDeletedElementsMap(),
      appState,
    );
    return (
      selected.length === 1 &&
      isMindmapNode(selected[0]) &&
      getConnectedChildren(
        selected[0],
        app.scene.getNonDeletedElementsMap(),
      ).length > 0
    );
  },
  perform(elements, appState, _, app) {
    const selected = getSelectedElements(
      app.scene.getNonDeletedElementsMap(),
      appState,
    );
    if (selected.length === 1 && isMindmapNode(selected[0])) {
      toggleMindmapCollapse(selected[0], app.scene);
    }
    return {
      captureUpdate: CaptureUpdateAction.IMMEDIATELY,
    };
  },
});
